<template>
  <NavigationMenu />
  <div class="section-container section-container-double-gap" id="error-page">
    <h2 class="section-container-heading">
      <p
        v-for="(line, index) in lines"
        :key="line.text"
        class="extra-large-text-list fade-up-animation"
        :class="{ 'special-text': line.special }">
        {{ line.text }}
      </p>
    </h2>
    <nuxt-link to="/contact" class="arrow-button arrow-button-bigger">
      <p class="heading-4-bold">Build What's Next</p>
      <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div>
    </nuxt-link>
  </div>

  <FooterComponent />
</template>

<script setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import icons from '@/icons';

const lines = [
  { text: 'No Page.', special: false },
  { text: 'No Limits.', special: true },
];

useFadeUpObserver();
</script>
